/**
 * @generated SignedSource<<c87eff09df3d4bdd89a2c088478efbb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueBodyContent$data = {
  readonly body: string;
  readonly bodyHTML: string;
  readonly " $fragmentType": "IssueBodyContent";
};
export type IssueBodyContent$key = {
  readonly " $data"?: IssueBodyContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodyContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "renderTasklistBlocks",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "unfurlReferences",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "bodyHTML",
      "storageKey": "bodyHTML(renderTasklistBlocks:true,unfurlReferences:true)"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "46c60d0983dd6495683f731a09a5d5f0";

export default node;
